import { render, staticRenderFns } from "./widget-attachment-preview.vue?vue&type=template&id=1fca1059&"
import script from "./widget-attachment-preview.vue?vue&type=script&lang=js&"
export * from "./widget-attachment-preview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports